class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute("data-product-id");
    this.variantId = this.getAttribute("data-variant-id");
    this.loginText = this.querySelector(".log_in_text");
    this.wishlisted = false;
    this.isProcessing = false;
    
    console.log("WishlistButton initialized:");
    console.log("Product ID:", this.productId);
    console.log("Variant ID:", this.variantId);
  }

  connectedCallback() {
    this.attachEventListeners();
    this.waitForCustomerId().then(() => this.checkWishlistStatus());
  }

  attachEventListeners() {
    this.addEventListener("click", this.handleWishlistToggle.bind(this));
  }

  async waitForCustomerId() {
    return new Promise((resolve) => {
      let checkInterval = setInterval(() => {
        if (typeof SWGetCustomerWishlistId === "function") {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  }

  async handleWishlistToggle(event) {
    console.log("=== WISHLIST TOGGLE CLICKED ===");
    console.log("isProcessing:", this.isProcessing);
    
    if (this.isProcessing) {
      console.log("BLOCKED: Already processing");
      return;
    }
    
    this.isProcessing = true;
    console.log("LOCKED: Setting isProcessing = true");

    if (typeof SWGetCustomerWishlistId !== "function") {
      console.error("SWGetCustomerWishlistId is missing.");
      this.isProcessing = false;
      return;
    }

    const customerId = SWGetCustomerWishlistId();

    if (!customerId || customerId === 0) {
      this.toggleLogInText();
      this.isProcessing = false;
      return;
    }

    if (this.wishlisted) {
      await this.removeFromWishlist();
    } else {
      await this.addToWishlist();
    }

    setTimeout(() => {
      console.log("UNLOCKED: Setting isProcessing = false");
      this.isProcessing = false;
    }, 500);
  }

  toggleLogInText() {
    this.loginText.classList.toggle("transform-0");
  }

  async addToWishlist() {
    console.log("Adding to wishlist:", this.productId, this.variantId);
    AddToSmartWishlist(this.productId, this.variantId);
    this.wishlisted = true;
    this.updateButtonState();
    document.dispatchEvent(new Event("wishlist:updated"));
  }

  async removeFromWishlist() {
    console.log("Removing from wishlist:", this.productId, this.variantId);
    RemoveFromSmartWishlist(this.productId, this.variantId);
    this.wishlisted = false;
    this.updateButtonState();
    document.dispatchEvent(new Event("wishlist:updated"));
  }

  async checkWishlistStatus() {
    if (typeof SWGetCustomerWishlistId !== "function") {
      return;
    }

    const customerId = SWGetCustomerWishlistId();

    if (!customerId || customerId === 0) {
      this.wishlisted = false;
      this.updateButtonState();
      return;
    }

    try {
      const response = await fetch(
        `https://thebearhouse.com/a/wishlist?type=api&customerid=${customerId}&version=1`
      );
      const data = await response.json();

      if (data.items && Array.isArray(data.items)) {
        this.wishlisted = data.items.some((item) => item.id == this.productId);
      }

      this.updateButtonState();
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  }

  updateButtonState() {
    const notWishlistedIcon = this.querySelector(".notWishlisted");
    const wishlistedIcon = this.querySelector(".wishlisted");

    if (!wishlistedIcon || !notWishlistedIcon) {
      return;
    }

    if (this.wishlisted) {
      wishlistedIcon.style.display = "block";
      notWishlistedIcon.style.display = "none";
    } else {
      wishlistedIcon.style.display = "none";
      notWishlistedIcon.style.display = "block";
    }
  }
}

if (!customElements.get("wishlist-button")) {
  customElements.define("wishlist-button", WishlistButton);
}